import React, { Fragment } from 'react';
import { Card, Col, Form, Input, InputNumber, Row, Select } from 'antd';
import { formatCurrency, parserNumber } from '../../../../utils';

export default (props) => {

	const { getFieldDecorator } = props.form;

	return (
		<Fragment>
			<Form layout={'vertical'}>
				<Card title="Thông tin bổ sung">
					<Row gutter={12}>
						<Col span={12}>
							<Form.Item label={'Website'}>
								{getFieldDecorator('website', {})(
									<Input maxLength={255} placeholder={'Nhập Website'} allowClear />
								)}
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item label={'Công nợ'}>
								{getFieldDecorator('totalDebt', {})(
									<InputNumber style={{ width: '100%' }} step={1000} formatter={formatCurrency}
															 parser={parserNumber} placeholder={'Nhập công nợ'} allowClear />
								)}
							</Form.Item>
						</Col>
					</Row>
				</Card>
			</Form>
		</Fragment>
	);
};

